// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component } from '@angular/core';
import { HeaderService } from '../../../header.service';
import { BehaviorSubject } from 'rxjs';
import { ALL_ORGS_ID } from '../../../../types/group';

@Component({
    selector: 'app-endpoints-overview',
    templateUrl: './endpoints-overview.component.html',
    styleUrls: ['./endpoints-overview.component.scss'],
    standalone: false
})
export class EndpointsOverviewComponent {
  selectedOrgId$: BehaviorSubject<string> = new BehaviorSubject<string>(ALL_ORGS_ID);

  constructor(private headerService: HeaderService) {
    this.selectedOrgId$ = this.headerService.orgSelectedChanged;
  }

}
